<template>
  <div>
    <Card style="width: 100%">
      <Row>
        <Col span="3">
          <Button v-if="laboratoryId !== 'dabf01da6c034feaa0b6df507b1ee009'" type="primary" size="large" style="width: 120px;" @click="showAddCase"><Icon type="md-add"></Icon>&nbsp;&nbsp;{{$t('newCase')}}</Button>
        </Col>
        <Col span="3" style="padding-top: 5px">
          {{$t('caseList.name')}}：
          <Input v-model="patName" clearable :placeholder="$t('caseList.name')" style="width: 120px"></Input>
        </Col>
        <Col span="4" style="padding-top: 5px">
          {{$t('pathologyNumber')}}：
          <Input v-model="pathology" clearable :placeholder="$t('pathologyNumber')" style="width: 150px"></Input>
        </Col>
        <Col span="5" style="padding-top: 5px">
          {{$t('caseStatus')}}：
          <Select v-model="caseStatus" clearable style="width:200px">
            <Option v-for="item in caseStatusList" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </Col>
        <Col span="7" style="padding-top: 5px">
          {{$t('entryTime')}}：
          <DatePicker v-model="inDateStart" type="datetime" :placeholder="$t('startingTime')" style="width: 180px" @on-open-change="chooseStartDate"></DatePicker>
          <Icon type="minus"></Icon>
          <DatePicker v-model="inDateEnd"  type="datetime" :placeholder="$t('endTime')" style="width: 180px"  :options="endDateOption" :disabled="canChooseEndDate" :readonly="canChooseEndDate"></DatePicker>
        </Col>
        <Col span="2">
          <Button type="primary" size="large" @click="search" id="search"><Icon type="md-search"></Icon>&nbsp;&nbsp;{{$t('inquire')}}</Button>
        </Col>
      </Row>
      <!-- 添加病例弹窗 -->
      <div  v-if="isShowAddCase">
        <add-new-case @isClosed="showAddCase"></add-new-case>
      </div>
    </Card>
  </div>
</template>

<script>
import Vue from 'vue'
import {formatDate} from '../../../utils/date'
import AddNewCase from '@/components/case/caseManager/addCase/AddNewCase'
export default {
  name: 'CaseSearch',
  components: {formatDate, AddNewCase},
  data () {
    return {
      laboratoryId: localStorage.getItem('laboratoryId'),
      caseType: 0,
      caseTypeList: [
        {
          label: '全部',
          value: 0
        },
        {
          label: '细胞',
          value: 1
        },
        {
          label: '组织',
          value: 2
        }
      ],
      patName: '',
      pathology: '',
      inDateStart: new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 30 * 60 * 60 * 1000),
      endDateOption: Object(),
      canChooseEndDate: true,
      inDateEnd: new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 2 * 60 * 60 * 1000 - 1),
      isShowAddCase: false,
      caseStatus: '',
      caseStatusList: ''
    }
  },
  // 在页面渲染之后执行
  mounted () {
    // 注册全局登录事件对象
    window.Event = new Vue()
    // 监听登录事件
    Event.$on('getCaseListEvent', function () {
      document.getElementById('search').click()
    })
  },
  methods: {
    // 设置结束日期
    chooseStartDate () {
      if (this.inDateStart !== '') {
        this.canChooseEndDate = false
        this.endDateOption = {
          disabledDate: date => { // 使用箭头函数可以访问的this
            return date && date.valueOf() < this.inDateStart - 86400000
          }
        }
      } else {
        this.canChooseEndDate = true
        this.inDateEnd = ''
      }
    },
    async getCaseStatusList () {
      let params = new URLSearchParams()
      // 分析方法，染色类型，病理类型，送检部门，病例类别，证件类型
      let types = 'blsczt'
      params.append('types', types)
      let suc = await this.$http.post(this.$vue.getData('GET_DIC_INFO_URL'), params)
      if (suc.data.result === '1') {
        let data = suc.data.data
        this.caseStatusList = data.blsczt
        if (this.caseStatusList && this.caseStatusList.length > 0) {
          this.caseStatus = this.caseStatusList[0].value
        }
      }
    },
    // 查询方法
    search () {
      // 校验时间先后
      if (this.inDateStart > this.inDateEnd) {
        this.$Message.error(this.$t('entryTimeTip'))
        this.inDateEnd = ''
        return
      }
      // 创建map，封装参数
      let map = new Map()
      map.set('patName', this.patName)
      map.set('pathology', this.pathology)
      map.set('caseStatus', this.caseStatus)
      if (this.inDateStart !== '' && this.inDateEnd !== '') {
        map.set('inDateStart', formatDate(this.inDateStart, 'yyyy-MM-dd hh:mm:ss'))
        map.set('inDateEnd', formatDate(this.inDateEnd, 'yyyy-MM-dd hh:mm:ss'))
      }
      this.$emit('search', map)
    },
    showAddCase () {
      this.isShowAddCase = !this.isShowAddCase
      // 如果isShowAddCase为false,刷新数据
      if (!this.isShowAddCase) {
        this.search()
      }
    }
  },
  beforeMount () {
    this.$vue = this
    this.getCaseStatusList()
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/components/base/search/CaseSearch.vue